import { Button, H2, InputEmail } from "@sellar-io/components";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { SpinnerLegacy } from "../../../../components";
import { Alert } from "../../../../components/alert/Alert";
import { InputLabel, InputContainer } from "@sellar-io/components";
import { LANDING } from "../../../../constants/routes";
import { useEvents } from "../../../../hooks";
import { useFirebaseUser } from "../../../../hooks/useFirebaseUser.shared";
import { Mixpanel } from "../../../../utils/mixpanel";
import { useUserPasswordReset } from "../../../../hooks/api/v2/user/useUserPasswordReset";

export function UserSignupForgotPassword({
  email,
}: {
  email?: string;
}): ReactElement {
  const { track } = useEvents();
  const { user } = useFirebaseUser();
  const [recoveryEmail, setRecoveryEmail] = useState(email ?? "");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const userPasswordReset = useUserPasswordReset();

  useEffect(() => {
    if (user) navigate(LANDING);
  }, [user, navigate]);

  const sendRecoveryEmail = async () => {
    setLoading(true);
    setErrorMessage("");
    try {
      await userPasswordReset.mutateAsync({ data: { email: recoveryEmail } });

      Mixpanel.track("Password Reset Requested");
      setMessage(
        `Click the link in the email we sent you to reset your password`,
      );
      track("Reset Password Link Requested");
    } catch {
      setErrorMessage(
        `A password reset email could not be sent to this email address.`,
      );
    }
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <SpinnerLegacy />
      ) : (
        <div className={"my-auto flex flex-col justify-center gap-4"}>
          <div className={"flex flex-col gap-2"}>
            <H2 className={"text-center"}>Reset your password</H2>
            <p className={"text-center"}>
              Enter the email address associated with your account, and we'll
              email you a link to reset your password.
            </p>
          </div>
          {errorMessage && <Alert type={"error"} message={errorMessage} />}
          {message && (
            <Alert
              type={"information"}
              title={"Reset link sent"}
              message={message}
            />
          )}

          <InputLabel>Email address</InputLabel>
          <InputContainer>
            <InputEmail
              required={true}
              value={recoveryEmail}
              onChange={(e) => setRecoveryEmail(e.target.value)}
            />
          </InputContainer>
          <Button className={"mt-4 w-full"} onClick={() => sendRecoveryEmail()}>
            Send reset link
          </Button>
        </div>
      )}
    </>
  );
}
